import React from "react";
import { connect } from "react-redux";
import moment from "moment";

import { isDownTimeReporterOpen, getAvailableProducts } from "state/app/selectors";
import { closeDownTimeReporter } from "state/app/actions";
import { isAppserverOnline, isProductAvailable } from "lib/validate";

import Button from "components/Button";
import ModalDialog from "components/ModalDialog";

import errorImage from "components/assets/images/product_notification.png";
import "./ProductDownTimeReporter.css";

const DATE_FORMAT = "DD/MM HH:mm";

class ProductDownTimeReporter extends React.Component {
  formatDate(dateTime) {
    return moment(dateTime).format(DATE_FORMAT);
  }

  getappDownTimeContent() {
    if(isAppserverOnline()) {
      return null;
    }

    return (
      <div>
        <p>The app will be undergoing maintenance on <span className="product-down-time-reporter__bold">Monday 22nd December</span> between <span className="product-down-time-reporter__bold">10:00-13:00 GMT</span>.</p>
        <p>During this period, our services will be temporarily unavailable. We apologise for any inconvenience this may cause and appreciate your understanding as we work to enhance your experience.</p>
      </div>
    );
  }

  getProductNotification(product, startDate, endDate) {
    return (
      <div>
        <p>We are working on improving {product} for the Teachers2Parents app. Our Services are paused whilst our Network Technicians work on improving our systems. This planned outage is expected from <span className="product-down-time-reporter__bold">{this.formatDate(startDate)}</span> to <span className="product-down-time-reporter__bold">{this.formatDate(endDate)}.</span></p>
      </div>
    );
  }

  getProductDownTimeContent(availableProducts) {
    const schoolMoneyContent = availableProducts.includes("school_money") && !isProductAvailable("school_money") ? this.getProductNotification("SchoolMoney", process.env.REACT_APP_SCHOOLMONEY_DOWN_TIME_START, process.env.REACT_APP_SCHOOLMONEY_DOWN_TIME_END) : null;
    const teachers2ParentsContent = availableProducts.includes("teachers") && !isProductAvailable("teachers") ? this.getProductNotification("Teachers2Parents", process.env.REACT_APP_TEACHERS2PARENTS_DOWN_TIME_START, process.env.REACT_APP_TEACHERS2PARENTS_DOWN_TIME_END) : null;
    if(schoolMoneyContent === null && teachers2ParentsContent === null) {return null;}
    return (
      <div>
        {teachers2ParentsContent}
        {schoolMoneyContent}
      </div>
    );
  }

  render() {
    const {availableProducts, isDownTimeReporterOpen} = this.props;
    const appDownTimeContent = this.getappDownTimeContent();

    const content = appDownTimeContent !== null ? appDownTimeContent : this.getProductDownTimeContent(availableProducts);
    if (content === null) {
      return null;
    }
    if( isDownTimeReporterOpen ) {
      return (
        <ModalDialog>
          <div>
            <img className="product-down-time-reporter__image" src={errorImage} alt="Product Notification" />
            <h1 className="product-down-time-reporter__title">System admin downtime</h1>
            {content}
            <p>Thank you for your patience.</p>
            <Button className="product-down-time-reporter__close-button" onClick={this.props.closeDownTimeReporter}>Close Notification</Button>
          </div>
        </ModalDialog>
      );
    }
    return null;
  }

}

export default connect(
  state => ({
    isDownTimeReporterOpen: isDownTimeReporterOpen(state),
    availableProducts: getAvailableProducts(state)
  }),
  { closeDownTimeReporter }
)(ProductDownTimeReporter);



// WEBPACK FOOTER //
// ./src/components/app/ProductDownTimeReporter.js